var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.25,
    fill: "#FBC108",
    fillOpacity: 0.0646
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2658 25.06H19.9705C19.4649 25.06 19.0552 24.6565 19.0552 24.1587V20.9141C19.0552 20.5157 18.7275 20.193 18.3229 20.193H16.8583C16.4537 20.193 16.126 20.5157 16.126 20.9141V24.1587C16.126 24.6565 15.7163 25.06 15.2107 25.06H11.9154C11.4097 25.06 11 24.6565 11 24.1587V17.2776C11 16.4488 11.3859 15.6657 12.0468 15.1531L17.2505 11.1157C17.45 10.9614 17.7312 10.9614 17.9304 11.1157L23.1348 15.1531C23.7957 15.6657 24.1812 16.4484 24.1812 17.2769V24.1587C24.1812 24.6565 23.7715 25.06 23.2658 25.06Z",
    fill: "#FBC108",
    fillOpacity: 0.864583
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3ea35de4b43ae1b306f79346b961d4a8.svg";
export { ForwardRef as ReactComponent };